/**
 * A versão publicada deste frontend.
 *
 * O `ops/publicar-frontend.sh` a calcula antes de compilar e a injeta como
 * `VITE_VERSAO`. O formato é `AAAAMMDD-HHMMSS-<commit>`: o commit identifica o
 * código e o horário desempata duas publicações do mesmo commit.
 *
 * ⚠️ Serve para **conferir olhando** se um cliente ficou atrás. A publicação
 * alcança todos os servidores de uma vez, mas já aconteceu de um ficar com
 * versão velha por 17 dias sem que nada reclamasse — e o sintoma era só a
 * ausência de telas novas. Com a versão na tela de login, isso se vê sem
 * entrar no sistema e sem abrir terminal.
 *
 * Em desenvolvimento não há publicação, então não há versão: dizer
 * "desenvolvimento" é mais honesto que inventar um número.
 */
export const VERSAO: string = import.meta.env.VITE_VERSAO || "desenvolvimento";

/** Só a data e a hora, para quem só quer saber se está recente. */
export const VERSAO_CURTA: string = (() => {
  const m = /^(\d{4})(\d{2})(\d{2})-(\d{2})(\d{2})/.exec(VERSAO);
  return m ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}` : VERSAO;
})();
